module.exports = __webpack_public_path__ + "static/ellis-brigham-skin-851373135f0f950303c790e14d2c48a0.jpg";